import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Progress, Label, Input } from 'reactstrap';
import classnames from 'classnames';

class Aside extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1'
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    return (
      <aside className="aside-menu" style={{
        background: "#f8f9fc",
        borderLeft: "2px solid #667eea"
      }}>
        <Nav tabs style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderBottom: "none"
        }}>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
              style={{
                color: this.state.activeTab === '1' ? "#667eea" : "rgba(255,255,255,0.8)",
                border: "none",
                fontWeight: "600",
                background: this.state.activeTab === '1' ? "#f8f9fc" : "transparent",
                borderRadius: "8px 8px 0 0",
                margin: "5px 2px 0"
              }}>
              <i className="icon-list"></i>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
              style={{
                color: this.state.activeTab === '2' ? "#667eea" : "rgba(255,255,255,0.8)",
                border: "none",
                fontWeight: "600",
                background: this.state.activeTab === '2' ? "#f8f9fc" : "transparent",
                borderRadius: "8px 8px 0 0",
                margin: "5px 2px 0"
              }}>
              <i className="icon-speech"></i>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '3' })}
              onClick={() => { this.toggle('3'); }}
              style={{
                color: this.state.activeTab === '3' ? "#667eea" : "rgba(255,255,255,0.8)",
                border: "none",
                fontWeight: "600",
                background: this.state.activeTab === '3' ? "#f8f9fc" : "transparent",
                borderRadius: "8px 8px 0 0",
                margin: "5px 2px 0"
              }}>
              <i className="icon-settings"></i>
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1" style={{ padding: "0" }}>
            <div style={{
              background: "linear-gradient(135deg, #667eea15 0%, #764ba210 100%)",
              padding: "10px 15px",
              borderBottom: "1px solid #e8ecf1",
              textAlign: "center"
            }}>
              <small style={{ fontWeight: "700", color: "#667eea", textTransform: "uppercase", letterSpacing: "1px" }}>Today</small>
            </div>
            <div style={{
              padding: "12px 15px",
              borderLeft: "3px solid #f7971e",
              margin: "8px 10px",
              borderRadius: "0 8px 8px 0",
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <div style={{ fontWeight: "600", fontSize: "13px", color: "#333" }}>Meeting with <strong>Lucas</strong></div>
              <small style={{ color: "#999" }}><i className="icon-calendar"></i>&nbsp; 1 - 3pm</small>
              <small style={{ color: "#999", marginLeft: "8px" }}><i className="icon-location-pin"></i>&nbsp; Palo Alto, CA</small>
            </div>
            <div style={{
              padding: "12px 15px",
              borderLeft: "3px solid #4facfe",
              margin: "8px 10px",
              borderRadius: "0 8px 8px 0",
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <div style={{ fontWeight: "600", fontSize: "13px", color: "#333" }}>Skype with <strong>Megan</strong></div>
              <small style={{ color: "#999" }}><i className="icon-calendar"></i>&nbsp; 4 - 5pm</small>
              <small style={{ color: "#999", marginLeft: "8px" }}><i className="icon-social-skype"></i>&nbsp; On-line</small>
            </div>
            <div style={{
              background: "linear-gradient(135deg, #667eea15 0%, #764ba210 100%)",
              padding: "10px 15px",
              borderBottom: "1px solid #e8ecf1",
              borderTop: "1px solid #e8ecf1",
              textAlign: "center"
            }}>
              <small style={{ fontWeight: "700", color: "#667eea", textTransform: "uppercase", letterSpacing: "1px" }}>Tomorrow</small>
            </div>
            <div style={{
              padding: "12px 15px",
              borderLeft: "3px solid #eb3349",
              margin: "8px 10px",
              borderRadius: "0 8px 8px 0",
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <div style={{ fontWeight: "600", fontSize: "13px", color: "#333" }}>New UI Project - <strong>deadline</strong></div>
              <small style={{ color: "#999" }}><i className="icon-calendar"></i>&nbsp; 10 - 11pm</small>
              <small style={{ color: "#999", marginLeft: "8px" }}><i className="icon-home"></i>&nbsp; creativeLabs HQ</small>
            </div>
            <div style={{
              padding: "12px 15px",
              borderLeft: "3px solid #11998e",
              margin: "8px 10px",
              borderRadius: "0 8px 8px 0",
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <div style={{ fontWeight: "600", fontSize: "13px", color: "#333" }}><strong>#10 Startups.Garden</strong> Meetup</div>
              <small style={{ color: "#999" }}><i className="icon-calendar"></i>&nbsp; 1 - 3pm</small>
              <small style={{ color: "#999", marginLeft: "8px" }}><i className="icon-location-pin"></i>&nbsp; Palo Alto, CA</small>
            </div>
            <div style={{
              padding: "12px 15px",
              borderLeft: "3px solid #667eea",
              margin: "8px 10px",
              borderRadius: "0 8px 8px 0",
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <div style={{ fontWeight: "600", fontSize: "13px", color: "#333" }}><strong>Team meeting</strong></div>
              <small style={{ color: "#999" }}><i className="icon-calendar"></i>&nbsp; 4 - 6pm</small>
              <small style={{ color: "#999", marginLeft: "8px" }}><i className="icon-home"></i>&nbsp; creativeLabs HQ</small>
            </div>
          </TabPane>
          <TabPane tabId="2" style={{ padding: "15px" }}>
            <div style={{ textAlign: "center", padding: "30px 10px", color: "#999" }}>
              <i className="icon-speech" style={{ fontSize: "40px", color: "#667eea", opacity: 0.5 }}></i>
              <p style={{ marginTop: "10px", fontWeight: "500" }}>No messages yet</p>
            </div>
          </TabPane>
          <TabPane tabId="3" style={{ padding: "15px" }}>
            <h6 style={{ color: "#667eea", fontWeight: "700", marginBottom: "15px" }}>
              <i className="icon-settings" style={{ marginRight: "8px" }}></i>
              Settings
            </h6>

            <div style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "12px 15px",
              marginBottom: "10px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <div className="clearfix">
                <small style={{ fontWeight: "600", color: "#333" }}>Option 1</small>
                <Label className="switch switch-text switch-pill switch-success switch-sm float-right">
                  <Input type="checkbox" className="switch-input" defaultChecked />
                  <span className="switch-label" data-on="On" data-off="Off"></span>
                  <span className="switch-handle"></span>
                </Label>
              </div>
              <small style={{ color: "#999" }}>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</small>
            </div>

            <div style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "12px 15px",
              marginBottom: "10px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <div className="clearfix">
                <small style={{ fontWeight: "600", color: "#333" }}>Option 2</small>
                <Label className="switch switch-text switch-pill switch-success switch-sm float-right">
                  <Input type="checkbox" className="switch-input" />
                  <span className="switch-label" data-on="On" data-off="Off"></span>
                  <span className="switch-handle"></span>
                </Label>
              </div>
              <small style={{ color: "#999" }}>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</small>
            </div>

            <hr style={{ borderColor: "#e8ecf1" }} />
            <h6 style={{ color: "#667eea", fontWeight: "700", marginBottom: "15px" }}>
              <i className="fa fa-server" style={{ marginRight: "8px" }}></i>
              System Utilization
            </h6>

            <div style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "12px 15px",
              marginBottom: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <small style={{ fontWeight: "600", color: "#333", textTransform: "uppercase" }}>CPU Usage</small>
              <Progress className="progress-xs mt-1" color="info" value="25" />
              <small style={{ color: "#999" }}>348 Processes. 1/4 Cores.</small>
            </div>

            <div style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "12px 15px",
              marginBottom: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <small style={{ fontWeight: "600", color: "#333", textTransform: "uppercase" }}>Memory Usage</small>
              <Progress className="progress-xs mt-1" color="warning" value="70" />
              <small style={{ color: "#999" }}>11444GB/16384MB</small>
            </div>

            <div style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "12px 15px",
              marginBottom: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <small style={{ fontWeight: "600", color: "#333", textTransform: "uppercase" }}>SSD 1 Usage</small>
              <Progress className="progress-xs mt-1" color="danger" value="95" />
              <small style={{ color: "#999" }}>243GB/256GB</small>
            </div>

            <div style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "12px 15px",
              marginBottom: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}>
              <small style={{ fontWeight: "600", color: "#333", textTransform: "uppercase" }}>SSD 2 Usage</small>
              <Progress className="progress-xs mt-1" color="success" value="10" />
              <small style={{ color: "#999" }}>25GB/256GB</small>
            </div>
          </TabPane>
        </TabContent>
      </aside>
    )
  }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js